import "./styles.scss";

import { useState } from "react";
import { useIntl } from "react-intl";
import { Asset } from "../../models/asset";
import Checkups from "./components/checkups";
import OilChange from "./components/oilChange";
import usePeriodicReviews from "../../hooks/usePeriodcReviews";
import { useMediaQuery } from "@mui/material";
import useAssets from "../../hooks/useAssets";

interface IIPeriodicReviewsProps {
  dialog: boolean;
  closeSidebar: () => void;
  asset: Asset | null;
  scheduleIds: string[];
  userRole: 'TOWER' | 'CONSULTANT' | 'MANAGER' | 'PARTNERSHIP';
}

const PeriodicReviews = ({ dialog, closeSidebar, asset, scheduleIds, userRole }: IIPeriodicReviewsProps) => {
  const intl = useIntl();
  const { activeTab, setActiveTab, blockchainData, loading } = usePeriodicReviews({ chassis: asset?.chassis ?? "", scheduleIds, userRole, dialog });
  const [hiddenIds, setHiddenIds] = useState<Set<string>>(new Set());
  const isResponsiveView = useMediaQuery("(max-width: 768px)");
  const { getAssetById } = useAssets();
  const summaryAsset = asset?.id ? getAssetById(asset.id) : undefined;
  const displayName = summaryAsset?.name && summaryAsset.name !== summaryAsset.chassis ? summaryAsset.name : undefined;
  const displayPlate = summaryAsset?.licensePlate && summaryAsset.licensePlate !== summaryAsset.chassis ? summaryAsset.licensePlate : undefined;

  return (
    <>
      <div className="bg-right-sidebar" onClick={() => closeSidebar()} />
      <div className={`right-sidebar ${isResponsiveView ? "!w-[80%]" : "!w-[550px]"}`}>
        <h3 className="flex gap-6 margin-bottom-20">
          <span className="rioglyph rioglyph-book"></span>
          {intl.formatMessage({ id: "intl-msg:common.periodicReviews" })}
        </h3>
        <div
          className="close-sidebar cursor-pointer"
          onClick={() => closeSidebar()}
        >
          <span className="rioglyph rioglyph-remove"></span>
        </div>

        {asset && (
          <>
            <div className="vehicle-header">
              <div className="vehicle-header__name">
                <span className="rioglyph rioglyph-truck text-size-16 margin-right-5"></span>
                <span className="text-size-14 font-semibold">{displayName ?? "-"}</span>
              </div>
              <div className="vehicle-header__details">
                <span className="vehicle-header__badge">
                  <span className="rioglyph rioglyph-barcode text-size-12 margin-right-4"></span>
                  {asset.chassis || "-"}
                </span>
                <span className="vehicle-header__badge">
                  <span className="rioglyph rioglyph-card text-size-12 margin-right-4"></span>
                  {displayPlate ?? "-"}
                </span>
              </div>
            </div>
            {hiddenIds.size > 0 && (
              <div className="mt-2 flex flex-wrap gap-2 items-center p-2 border rounded-lg border-color-light bg-lightest">
                <span className="text-size-12 text-color-gray mr-2">{intl.formatMessage({ id: "intl-msg:periodicReviews.periodicReviews.hiddenReviews" })}</span>
                {[...hiddenIds].map(name => (
                  <button
                    key={name}
                    type="button"
                    className="btn btn-sm btn-default flex items-center gap-4"
                    onClick={() => setHiddenIds(prev => { const next = new Set(prev); next.delete(name); return next; })}
                  >
                    <span>{name}</span>
                    <span className="rioglyph rioglyph-eye" />
                  </button>
                ))}
              </div>
            )}
          </>
        )}

        <div className="w-full flex-1 min-h-0 flex flex-col">
          <div className="p-0 flex-1 min-h-0 flex flex-col">
            {/* <div className="flex space-x-8 mb-6">
              <button
                onClick={() => setActiveTab("revisoes")}
                className={`text-size-16 font-semibold ${
                  activeTab === "revisoes"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
              >
                Revisões
              </button>
              <button
                // onClick={() => setActiveTab("trocaDeOleo")}
                className={`text-size-16 font-semibold ${
                  activeTab === "trocaDeOleo"
                    ? "border-b-2 border-black"
                    : "text-gray-400"
                }`}
                style={{ cursor: "not-allowed" }}
              >
                Troca de óleo
              </button>
            </div> */}

            {activeTab === "revisoes" && <Checkups asset={asset} blockchainData={blockchainData} loading={loading} isEnhanced={true} userRole={userRole} hiddenIds={hiddenIds} setHiddenIds={setHiddenIds} />}

            {activeTab === "trocaDeOleo" && <OilChange asset={asset} blockchainData={blockchainData} loading={loading} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default PeriodicReviews;
